/**
 * Constants that can be used as identifiers for Dependency Injection.
 *
 * Because of the micro-frontends it is possible to have 2 different
 * versions of a class - moduleA.Clazz !== moduleB.Clazz.
 *
 * This leads to `identifier not found` errors when injecting objects.
 * Using Symbols as keys solves this problem.
 */

export namespace DependencyKey {
  export const RegionsFetcher = Symbol.for('RegionsFetcher');
  export const RegionCreator = Symbol.for('RegionCreator');
  export const RegionUpdater = Symbol.for('RegionUpdater');
  export const RegionsDeleter = Symbol.for('RegionsDeleter');
  export const GeoLocationProvider = Symbol.for('GeoLocationProvider');

  export const CampaignAudienceTransformer = Symbol.for('CampaignAudienceTransformer');

  export const UserActionsApi = Symbol.for('UserActionsApi');
  export const UserEventOccurrencesApi = Symbol.for('UserEventOccurrencesApi');

  export const AudienceModelFactory = Symbol.for('AudienceModelFactory');
  export const AudienceEmptyMatcherFactory = Symbol.for('AudienceEmptyMatcherFactory');
  export const AudienceProtoMatcherFactory = Symbol.for('AudienceProtoMatcherFactory');

  export const AudienceSelectorModelFactory = Symbol.for('AudienceSelectorModelFactory');

  export const AudienceLimiter = Symbol.for('AudienceLimiter');

  export const AudienceEstimatesApi = Symbol.for('AudienceEstimatesApi');
  export const AudienceProtoValidationApi = Symbol.for('AudienceProtoValidationApi');
  export const EventParameterCheckingApi = Symbol.for('EventParameterCheckingApi');
  export const DashboardNotificationsApi = Symbol.for('DashboardNotificationApi');
  export const PagesApi = Symbol.for('PagesApi');
  export const RealtimeNotificationsApi = Symbol.for('RealtimeNotificationsApi');
  export const NotificationRegistry = Symbol.for('NotificationRegistry');
  export const SegmentationEventApi = Symbol.for('SegmentationEventApi');
}
